/**
 * Checks if there is a valid, completed exchange offer and redirect if not
 */
export default defineNuxtRouteMiddleware((to) => {
    const localeRoute = useLocaleRoute();
    const exchangeStore = useExchangeStore();

    if (!exchangeStore.exchangeCompletedOffers.length) {
        return navigateTo(localeRoute({ name: 'esav-exchange-step-1', params: { bookingId: to.params.bookingId as string } }));
    }
});
